module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 37.98 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "РЎР»РѕР№_2",
      "data-name": "РЎР»РѕР№ 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "РЎР»РѕР№_1-2",
      "data-name": "РЎР»РѕР№ 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M0,17.69A17.5,17.5,0,0,1,34.62,13.9c.08.37.22.48.59.46.61,0,1.23,0,1.84,0a.84.84,0,0,1,.85.5.76.76,0,0,1-.19.91c-1.32,1.51-2.63,3-4,4.52a.79.79,0,0,1-1.31,0q-2-2.26-4-4.55a.77.77,0,0,1-.18-.87.81.81,0,0,1,.8-.51c.59,0,1.19,0,1.79,0,.42,0,.54-.07.41-.52a14.26,14.26,0,0,0-27.9,1.83,14.25,14.25,0,0,0,26.35,9.15,2,2,0,0,1,1-.95,1.64,1.64,0,0,1,1.83.44,1.6,1.6,0,0,1,.15,2,17.16,17.16,0,0,1-4.88,5.4A17.52,17.52,0,0,1,.15,19.86,14.83,14.83,0,0,1,0,17.69Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M19,10.25c0,1.49,0,3,0,4.48a.88.88,0,0,0,.31.72,2.26,2.26,0,0,1,.9,1.61.56.56,0,0,0,.34.48q2.7,1.55,5.38,3.11a1.48,1.48,0,1,1-1.47,2.56q-2.67-1.53-5.33-3.09a.71.71,0,0,0-.68-.08,2.7,2.7,0,0,1-2.81-4.51,1.2,1.2,0,0,0,.42-1c0-3,0-5.94,0-8.91A1.43,1.43,0,0,1,17,4.18a1.48,1.48,0,0,1,1.63.41A1.67,1.67,0,0,1,19,5.76C19,7.26,19,8.75,19,10.25Zm-.27,7.21a1.2,1.2,0,0,0-1.23-1.23,1.32,1.32,0,0,0-1.24,1.3,1.26,1.26,0,0,0,1.25,1.22A1.2,1.2,0,0,0,18.72,17.46Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa41b60","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/duration.vue
// module id = 6c513acbae9bf8073207
// module chunks = 89